import { useMemo } from "react";
// Meant for objects that will never change
export const useMemoObj = <
  T extends Record<string, any> | Record<string, any>[],
>(
  obj: T,
): T => {
  return useMemo(() => obj, []);
};
